import React from 'react';
import { Route, Switch, Redirect  } from "react-router-dom";
import VisitorPass from './components/visitorPass';

function Routers() {  
  return (
   
    <main>
        <Switch>
            <Route path="/visitorpass" component={VisitorPass} exact />
            <Route path="/visitorpass/:id" component={VisitorPass} exact />
            <Redirect from="/" to="/visitorpass" />
        </Switch>
    </main>
  );
}

export default Routers;
